import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { FormattedMessage, useIntl } from 'react-intl'
import messages from '../../messages'
import { Tooltip } from '@material-ui/core'
import { Formik, Field } from 'formik'
import LiquidInput from '@src/components/LiquidInput'
import { handleTabDelimitedText } from '@src/routes/Configurators/utils/TabDelimitedData'
import { TubeProduct } from '@src/routes/Configurators/utils/enum'
import InfoIcon from '@material-ui/icons/Info'
import styles from '@src/routes/Configurators/utils/styles'
import clsx from 'clsx'

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: theme.palette.common.black,
    fontSize: theme.typography.pxToRem(14),
    marginBottom: theme.spacing(2),
  },
  textarea: {
    '& textarea': {
      overflow: 'auto',
    },
  },
  InfoPopup: {
    maxWidth: theme.spacing(64),
    backgroundColor: theme.palette.common.white,
    position: 'relative',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: '1px 1px 20px 1px lightgrey',
    padding: theme.spacing(5),
    fontSize: theme.typography.pxToRem(12),
    color: '#1b1b25',
    borderRadius: '2%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  arrow: {
    color: theme.palette.common.white,
  },
  InfoIcon: {
    position: 'relative',
    fontSize: theme.typography.pxToRem(16),
    top: theme.spacing(0.5),
    marginLeft: theme.spacing(1.5),
  },
  icon: {
    fontSize: theme.typography.pxToRem(16),
    verticalAlign: 'middle',
  },
  IconButton: {
    outlined: true,
    padding: theme.spacing(1),
  },
  tooltipMsg: {
    marginBottom: theme.spacing(4),
  },
}))
const CopyEntry = (data) => {
  const classes = useStyles()
  const intl = useIntl()
  const GlobalCSS = styles()

  return (
    <div>
      <span className={classes.text}>
        <FormattedMessage {...messages.CONF_COPY_ENTRY_HEADING} />
      </span>
      <Tooltip
        title={
          <React.Fragment>
            <div className={classes.tooltipMsg}>
              <FormattedMessage {...messages.CONF_COPY_PASTE_TOOLTIPMSG1} />
            </div>

            {data.productDetails.productType === TubeProduct.Cpeptide ? (
              <FormattedMessage
                {...messages[
                  `CONF_COPY_PASTE_TOOLTIPMSG_${data.productDetails.countryCode}_${data.productDetails.productType}`
                ]}
              />
            ) : (
              <FormattedMessage
                {...messages[
                  `CONF_COPY_PASTE_TOOLTIPMSG_${data.productDetails.productType}`
                ]}
              />
            )}
          </React.Fragment>
        }
        classes={{ tooltip: classes.InfoPopup, arrow: classes.arrow }}
        arrow
        placement="bottom-end"
      >
        <InfoIcon
          aria-label="info"
          className={classes.InfoIcon}
          color="primary"
        ></InfoIcon>
      </Tooltip>
      <Formik
        initialValues={{ copyPasteText: '' }}
        onSubmit={(values, actions) => {
          setTimeout(() => {
            actions.setSubmitting(false)
          }, 1000)
        }}
      >
        {() => (
          <>
            <Field
              name="copyPasteText"
              component={LiquidInput}
              className={clsx(
                classes.textarea,
                GlobalCSS.placeHolderColorChanges
              )}
              filled
              placeholder={intl.formatMessage(
                messages.CONF_PASTE_ENTRIES_HERE_EDIT
              )}
              multiline
              rows={5}
              cols={30}
              onKeyDown={(e) => {
                if (e.key === 'Tab') {
                  const event = handleTabDelimitedText(e)
                  data.handlechange(event)
                }
              }}
              value={data.text}
              onChange={(e) => data.handlechange(e)}
            />
          </>
        )}
      </Formik>
    </div>
  )
}
export default CopyEntry
